import {useToast} from 'vue-toastification'
import {Modal} from 'bootstrap'
import useApi from "@/composables/useApi";

export default function useFinancialItem(type) {
    const toast = useToast()
    const MODAL_ID = 'modalId'
    const {fetchResource, createResource, updateResource, deleteResource} = useApi()

    const baseStructure = {
        title: '', unit: '', type,
    }

    const getTypeLabel = function (type) {
        switch (type) {
            case 'material':
                return 'مواد';
            case 'product':
                return 'محصول';
            case 'energy':
                return 'انرژی';
            default:
                return type;
        }
    }

    const getModal = () => Modal.getOrCreateInstance(document.getElementById(MODAL_ID))

    const data = () => ({
        items: [],
        newItem: structuredClone(baseStructure),
        editedItem: null,
        editIndex: null,
        tableHeaders: ['عنوان ' + getTypeLabel(type), 'واحد سنجش'],
        tableFields: ['title', 'unit'],
    })

    const methods = {
        validateItem(item) {
            if (!item.title || !item.unit) {
                toast.error('همه فیلدها را کامل وارد کنید!')
                return false
            }
            return true
        },

        async fetchData() {
            const query = new URLSearchParams({type}).toString()
            const response = await fetchResource('/v2/finance-and-productivity/financial-items?' + query)
            this.items = response.data
        },

        async addItem() {
            if (!this.validateItem(this.newItem)) return

            const response = await createResource('/v2/finance-and-productivity/financial-items', this.newItem)

            this.items.unshift(response.data)
            Object.assign(this.newItem, baseStructure)
        },

        async removeItem(index) {
            const deletedItem = this.items.find((_, i) => i === index);
            await deleteResource('/v2/finance-and-productivity/financial-items/' + deletedItem.id)
            this.items = this.items.filter((_, i) => i !== index)
        },

        async startEditing(item, index) {
            this.editedItem = structuredClone(item)
            this.editIndex = index
        },

        async editItem() {
            if (!this.validateItem(this.editedItem) || this.editIndex === null) throw new Error();

            const response = await updateResource('/v2/finance-and-productivity/financial-items/' + this.editedItem.id, this.editedItem)

            this.items.splice(this.editIndex, 1, response.data)
            this.editIndex = null
            this.editedItem = null
        },

        async openEditModal(item, index) {
            await this.startEditing(item, index)
            getModal().show()
        },

        async handleUpdate() {
            try {
                await this.editItem()
                getModal().hide()
            } catch (error) {
                console.log(error.message)
            }
        }
    }

    return {
        data, methods,
    }
}
